// 封装axios
import axios from 'axios';
// import router from 'vue-router';
import router from '../router';
import '../style/request.css'
import { Message } from 'element-ui';

var isRefreshToken = false;

// 创建axios实例
const requests = axios.create({
    // 生产和开发环境的不同 采用全局变量的模式
    baseURL: process.env.VUE_APP_SERVICE_URL, //
    // 超时的设置
    timeout: 60000
})

// 构建请求拦截器
// 在一般请求ajax的时候 都需要将token通过header传进去！
requests.interceptors.request.use(
    config => {
        if (config.url.indexOf("getToken") != -1) {
            isRefreshToken = true;
            config.headers['Refresh-Token'] = localStorage.getItem('refreshToken');
        } else {
            isRefreshToken = false;
            const accessToken = localStorage.getItem("accessToken");
            accessToken && (config.headers['Access-Token'] = accessToken);
        }
        console.log("请求拦截" + config.url);
        return config;
    },
    err,
)

// 错误的设置
const err = (error) => {
    Message.error({message:'Network Error'});
    if (error.response) {
        if (error.response.status === 400) {
        }
    }
    return Promise.reject(error);
}
// 构建回调拦截器
// api返回的是掉出登录 全局拦截跳转
//网络请求应该放到一个队列中，
requests.interceptors.response.use((response) => {
    const res = response.data;
    console.log("请求响应", res)

    if (isRefreshToken) {

        if (res.code == 1001) { //refreshtoken过期，需要重新登陆
            console.log("失效");
            isRefreshToken = false;
            router.replace("/login");
            localStorage.clear();
        } else {
            console.log("刷新accessToken为", res.data);
            localStorage.setItem('accessToken', res.data);
            isRefreshToken = false;
        }
    } else {
        isRefreshToken = false;
        if (res.code == 1000) { // 全局的登录超时，重新刷新token
            console.log("超时")
            refreshToken();
            return Promise.reject(res)
        } else if (res.code == 999) { //token格式错误，一般为undefine
            console.log("token格式错误")
            refreshToken();
            return Promise.reject(res)
        } else if (res.code == 1001) { //refreshtoken过期，需要重新登陆
            router.replace('/login');
            localStorage.clear();
            return Promise.reject(res)
        } else {
            return res;
        }
    }
    return res;
}, err)

function refreshToken() {
    setTimeout(() => {
        let headers = {
            'Content-Type': 'application/json',
        };
        headers['Refresh-Token'] = localStorage.getItem('refreshToken');
        let url = "getToken";
        requests({
            headers,
            url,
            method: 'post',
        });
    }, 1000);
}

export default requests;


// WEBPACK FOOTER //
// ./src/script/requests.js